import { ArrowRight } from "lucide-react";
import { heroContent } from "@/app/content/landingContent";

export function HeroSection() {
  return (
    <section
      className="bg-white py-24 md:py-32 px-6"
      aria-labelledby="hero-heading"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-5xl">
          <h1
            id="hero-heading"
            className="text-[clamp(2.25rem,5vw,4.5rem)] mb-8 text-slate-900 leading-[1.1] tracking-tight font-bold"
          >
            {heroContent.heading}
          </h1>

          <p className="text-[clamp(1.125rem,2vw,1.25rem)] mb-12 leading-relaxed text-slate-600 max-w-prose">
            {heroContent.body}
          </p>

          <div className="flex flex-col sm:flex-row gap-6 items-start">
            <a
              href={heroContent.primaryCta.href}
              className="inline-flex items-center gap-4 bg-[#004f4f] text-white px-8 py-4 rounded-full hover:bg-[#003d3d] focus:outline-none focus:ring-4 focus:ring-[#004f4f] focus:ring-offset-4 transition-colors font-bold text-base"
            >
              {heroContent.primaryCta.label}
              <ArrowRight size={20} aria-hidden="true" />
            </a>

            <a
              href={heroContent.secondaryCta.href}
              className="inline-flex items-center justify-center text-[#004f4f] font-semibold text-base underline decoration-2 underline-offset-4 hover:text-[#003d3d] focus:outline-none focus:ring-4 focus:ring-[#004f4f] rounded-md px-4 py-4 transition-colors"
            >
              {heroContent.secondaryCta.label}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
